import clsx from 'clsx';
import React from 'react';

import DynamicComponent from '@/storyblok/components/DynamicComponent';

import Tag from '../Tag';
import styles from './DescriptionList.module.scss';

type ListItem = {
  term: string;
  details?: string;
  detailsIsInMono?: boolean;
  tags?: any;
  tagsWithLinks?: any[];
  url?: string;
};

interface Props {
  items: ListItem[];
  className?: string;
  foregroundColor?: string;
  padding?: boolean;
  mobilePadding?: boolean;
}

const DescriptionList: React.FC<Props> = ({
  className = '',
  items = [],
  foregroundColor = '',
  padding,
  mobilePadding
}) => (
  <dl
    className={[styles.DescriptionList, className].join(' ')}
    style={
      {
        '--description-list-foreground-color': foregroundColor
      } as React.CSSProperties
    }
  >
    {items.map(({ term, details, tags, url, tagsWithLinks = [], detailsIsInMono = false }) => (
      <React.Fragment key={term}>
        <dd className={styles.DescriptionList__term}>{term}</dd>
        <dt
          className={clsx(styles.DescriptionList__details, [
            padding && styles['DescriptionList__details--padding'],
            !mobilePadding && styles['DescriptionList__details--noPaddingMobile']
          ])}
        >
          {/* Render details, details with url, or tags */}
          {(url && <a href={url}>{details}</a>) ||
            (details && (
              <span className={clsx(detailsIsInMono && 'u-mono-font')}>{details}</span>
            )) ||
            (tagsWithLinks.length > 0 ? (
              <DynamicComponent blok={tagsWithLinks[0]} />
            ) : (
              tags.length && tags.split(',').map((tag, i) => <Tag key={i} label={tag} />)
            )) ||
            ''}
        </dt>
      </React.Fragment>
    ))}
  </dl>
);

export default DescriptionList;
